import { useState, useRef, useEffect, useCallback } from 'react';
import { preventDefaults } from 'apps/web_forms/components/Form/utils';

export const useDragAndDrop = (handleDropCallback) => {
  const [dragEnter, setDragEnter] = useState(false);
  const dropRef = useRef(null);

  const handleDragEnter = useCallback((e) => {
    preventDefaults(e);
    setDragEnter(true);
  }, [preventDefaults]);

  const handleDragLeave = useCallback((e) => {
    preventDefaults(e);
    setDragEnter(false);
  }, [preventDefaults]);

  const handleDropInternal = useCallback((e) => {
    preventDefaults(e);
    setDragEnter(false);
    if (handleDropCallback) {
      handleDropCallback(e);
    }
  }, [preventDefaults, handleDropCallback]);

  useEffect(() => {
    const dropAreaElement = dropRef.current;
    if (!dropAreaElement) return;

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      dropAreaElement.addEventListener(eventName, preventDefaults, false);
    });
    dropAreaElement.addEventListener('dragenter', handleDragEnter, false);
    dropAreaElement.addEventListener('dragover', handleDragEnter, false);
    dropAreaElement.addEventListener('dragleave', handleDragLeave, false);
    dropAreaElement.addEventListener('drop', handleDropInternal, false);

    // Clean up listeners on unmount or when dependencies change.
    return () => {
      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
        dropAreaElement.removeEventListener(eventName, preventDefaults, false);
      });
      dropAreaElement.removeEventListener('dragenter', handleDragEnter, false);
      dropAreaElement.removeEventListener('dragover', handleDragEnter, false);
      dropAreaElement.removeEventListener('dragleave', handleDragLeave, false);
      dropAreaElement.removeEventListener('drop', handleDropInternal, false);
    };
  }, [preventDefaults, handleDragEnter, handleDragLeave, handleDropInternal]);

  return { dropRef, dragEnter };
};
